import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
// globals
import { SLA_AIRPORT_BOOKINGTYPE_MAPPING, SLA_TERMINALS_BOOKINGTYPE_MAPPING } from 'src/globals';

interface SlaPricingState {
    hasFiltersApplied: boolean;
    airportCity: string;
    bookingType: 'ABC' | 'CarouselCollection' | '';
    terminal: string;
}

const initialState: SlaPricingState = {
    hasFiltersApplied: false,
    airportCity: '',
    bookingType: '',
    terminal: '',
};

export const slaAuditSlice = createSlice({
    name: 'slaAudit',
    initialState,
    reducers: {
        setAirport: (state, action: PayloadAction<any>) => {
            const value = action.payload;

            state.airportCity = value;
            state.bookingType = SLA_AIRPORT_BOOKINGTYPE_MAPPING[value][0].value;
            state.terminal = SLA_TERMINALS_BOOKINGTYPE_MAPPING[value][0].value;
        },
        setBookingType: (state, action: PayloadAction<any>) => {
            state.bookingType = action.payload;
        },
        setTerminal: (state, action: PayloadAction<any>) => {
            state.terminal = action.payload;
        },
        applyFilters: (state) => {
            state.hasFiltersApplied = true;
        },
        clearFilters: (state, action: PayloadAction<any>) => {
            state.hasFiltersApplied = false;

            state.airportCity = action.payload.airportCity;
            state.bookingType = action.payload.bookingType;
            state.terminal = action.payload.terminal;
        },
    },
});

export const {
    setAirport,
    setBookingType,
    setTerminal,
    applyFilters,
    clearFilters,
} = slaAuditSlice.actions;

export default slaAuditSlice.reducer;
